var _rect, _rect2, _rect3, _path, _rect4, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalPostOffice = function SvgLocalPostOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.47778,
    y: 9.97021,
    width: 41.7512,
    height: 37.3892,
    rx: 0.623153,
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9557,
    y: 21.187,
    width: 26.7956,
    height: 26.1724,
    rx: 0.623153,
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4187,
    y: 21.187,
    width: 14.3325,
    height: 26.1724,
    rx: 0.623153,
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8462 13.5386H30.1539",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0769,
    y: 33.8462,
    width: 28.9231,
    height: 16.6154,
    rx: 2.49261,
    fill: "#2F6D7B",
    stroke: "black",
    strokeWidth: 1.24631
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6923 40.8614L45.6615 38.769L47.7538 40.8614L49.8461 38.769L51.9384 40.8614",
    stroke: "white",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9172 44.2601L38.2959 46.769H30.7693L31.148 44.2601C31.2427 43.55 31.8107 43.0767 32.5208 43.0767H34.5089H36.4971C37.2072 43.0767 37.8225 43.5974 37.9172 44.2601Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6924 39.2424C36.0711 39.5738 36.3078 40.0472 36.3078 40.5679C36.3078 40.6625 36.3078 40.7099 36.3078 40.8045C36.2131 41.6566 35.4557 42.3193 34.5563 42.3193C33.5622 42.3193 32.8048 41.5146 32.8048 40.5679C32.8048 40.4732 32.8048 40.3785 32.8048 40.2838C32.9468 39.4318 33.6569 38.769 34.5563 38.769C34.6036 38.769 34.6983 38.769 34.7456 38.769C35.077 38.8637 35.4084 39.0057 35.6924 39.2424Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0769 43.6924V51.969C27.0769 53.3456 28.1929 54.4616 29.5695 54.4616H53.5074C54.884 54.4616 56 53.3456 56 51.969V43.6924",
    stroke: "black",
    strokeWidth: 1.24631
  })));
};
export default SvgLocalPostOffice;